import { render, staticRenderFns } from "./HeaderRight.vue?vue&type=template&id=b3bc70ce&"
import script from "./HeaderRight.vue?vue&type=script&lang=js&"
export * from "./HeaderRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports